import orderInstance from '../instance'

const distanceGet = (data) => {
  return orderInstance.post('/customers/geoData', data)
}

export default distanceGet
